import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpgradeAllContentItemsDocument } from './upgrade-all.generated';

export const useUpgradeAllContentItems = (
  options: ApiOptions<typeof UpgradeAllContentItemsDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(UpgradeAllContentItemsDocument, {
    ...useNotifications(UpgradeAllContentItemsDocument, {
      failure: t('api.content_items.upgrade_all_error'),
      success: t('api.content_items.upgrade_all_success'),
    }),

    ...options,
  });
};
